import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

/**
 * LOCKED — canonical AA pill set (verdant's darkened inks, measured 4.56–7.68
 * in round 1; scorecard mandatory fix #2). Never colour alone: the label text
 * always renders. Do NOT restyle per surface — add a tone here if one is
 * genuinely missing.
 *
 *   done    = Done · Mapped · Approved · Best fit · Passed · On track · Merged
 *   review  = Review · Needs a person · Partial · At risk · Waiting
 *   blocked = Blocked · Failed · late · Rejected
 *   neutral = Scheduled · Planned · Cheaper · Fallback · Pencilled
 *   people  = Growth move · person/lane accents
 *   proposed= what PX proposes (mint tint — never a "selected" state)
 *   decided = aubergine — what has been decided (approved chips)
 */
const statusPill = cva(
  'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      tone: {
        done: 'bg-done-bg text-done',
        review: 'bg-review-bg text-review',
        blocked: 'bg-blocked-bg text-blocked',
        neutral: 'bg-neutral-bg text-neutral',
        people: 'bg-people-bg text-people-ink',
        proposed: 'bg-accent text-accent-foreground',
        decided: 'bg-primary text-primary-foreground',
      },
    },
    defaultVariants: { tone: 'neutral' },
  }
)

export type StatusTone = NonNullable<VariantProps<typeof statusPill>['tone']>

export function StatusPill({
  tone,
  className,
  children,
}: {
  tone?: StatusTone
  className?: string
  children: React.ReactNode
}) {
  return <span className={cn(statusPill({ tone }), className)}>{children}</span>
}
